<template>
  <div class="headerContent">
    <span class="mainPageTitle">{{ title }}</span>
    <span v-if="!removeTitle" class="headerRightText">AI Driven 22 Document Classsification</span>
  </div>
</template>

<script>
// import Sidebar from './Sidebar.vue'

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    removeTitle: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    // Navbar,
    // Sidebar,
  },
}
</script>

<style scoped>
.headerContent {
  background-color: var(--secondary-color);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 80px !important;
}
.headerRightText {
  color: var(--primary-color);
  text-align: right;
  font-family: Archivo;
  font-size: 20px;
  font-style: italic;
  font-weight: 400;
  line-height: 91.5%; /* 18.3px */
}
.headerText {
  color: var(--primary-color);
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-variant: all-small-caps;
  letter-spacing: 0.2px;
  font-weight: bold;
}
</style>
